var Webprofy = {
    toggleLabel : function($elements, enable){
        var disabled = !enable;
        $elements.each(function(){
            $(this).toggleClass('disabled', disabled).find('input').prop('disabled', disabled);
        });
        return this;
    },
    setInputStatus : function($elements, ok, message){
        var html = '<span class="status-' + (ok ? 'ok' : 'error') + '">' + (message || '') + '</span>';
        $elements.each(function(){
            $(this).closest('.field').find('.status').html(html);
        });
        return this;
    },
    oldIeCheck : $('html').hasClass('bx-ie9') || $('html').hasClass('bx-ie8'),

    isOldIe: function(){
        return this.oldIeCheck;
    }
};
// Скрипт для форм form.result.new
$.fn.initWebForm = function(block, options) {
    /*
    WP_SUCCESS_MODE

    S1 - Редирект на страницу "Спасибо"
    S2 - Редирект на текущую страницу (перезагрузка страницы)
    S3 - Редирект на текущую страницу с показом информационного попапа, после загрузки страницы
    S4 - Замена содержимого формы на сообщение об успешной отправке без изменения размера формы
    S5 - Замена содержимого формы на сообщение об успешной отправке с изменением размера формы
    S6 - Замена содержимого формы на сообщение об успешной отправке с последующим полным скрытием формы после небольшой паузы (закрыванием попапа).
    S7 - Показ сообщения об успешной отправке в попапе и очистка (сброс) формы.
    S8 - Показ сообщения об успешной отправке в попапе БЕЗ очистки (сброса) формы.
    */

    var default_options = {
        WP_SUCCESS_MODE: 'S5'
    };

    options = $.extend({}, default_options, options);

    var $form = $(this);
    var blockName = $form.find('input[name=block_name]').val() || block || 'form-standart';
    var $context = $form.closest('.'+blockName);

    var $inputs = $form.find('[data-fieldname]');
    var $fields = $('.' + blockName + '__field', $context);
    var $successMessage = $('.success-message-modal',$context);
    var isAjax = $context.hasClass('js-ajax') || $form.hasClass('js-ajax');

    var MESS = {
        'browser': 'Браузер',
        'windowsize': 'Размер окна',
        'utm_source': 'UTM источник',
        'utm_campaign': 'UTM кампания',
        'utm_medium': 'UTM медиа',
        'utm_keyword': 'UTM ключевые слова',
        'location': 'Текущая страница',
        'message_sent': 'Сообщение отправлено'
    };

    if($form.data('form-initiated') !== undefined) return;
    $form.data('form-initiated', true);

    prepareFieldsValidation();
    initFormSubmit();

    function getFieldsData(){
        var data = {};
        $form.find('[data-fieldname]').each(function(){
            data[$(this).data('fieldname')] = $(this).val();
        });
        return data;
    }

    function getCookie(name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    /*function getUtms() {
        var utm = getCookie('__utmz');
        utms = {};
        if(utm){
            eval(utm.replace(/.*?(utm.*?)=([^|]*)[|]?/g, "utms['$1'] = '$2';\n"));
        }
        return utms;
    }*/

    function getUserInfo(){
        var userinfo = {};
        userinfo['browser'] = navigator.userAgent;
        userinfo['windowsize'] = $(window).width() + "×" + $(window).height();
        userinfo['location'] = document.location.href;
        //utms = getUtms();
        /*if(utms.utmcsr){
            userinfo['utm_source'] = utms.utmcsr;
        }
        if(utms.utmccn){
            userinfo['utm_campaign'] = utms.utmccn;
        }
        if(utms.utmcmd){
            userinfo['utm_medium'] = utms.utmcmd;
        }
        if(utms.utmcmd){
            userinfo['utm_keyword'] = utms.utmctr;
        }*/

        var stringresult = "";
        $.each(userinfo, function(key, value){
            stringresult += MESS[key] + ": " + value + "\n";
        });
        return stringresult;
    }

    function prepareFieldsValidation () {
        // Обеспечиваем совместимость с предыдущим решением
        $fields.filter('[data-necessary]').each(function () {
            var $field = $(this);
            var $inputs = $('input, textarea, select', $field);

            $inputs.each(function () {
                var $this = $(this);
                $this.removeAttr('required').data('required', true);

                $this.on('click keydown change', function() {
                    $(this).closest('.'+blockName+'__field').removeClass('is-none');
                });
            });
        });

        $('input[data-necessary], textarea[data-necessary], select[data-necessary]', $form).each(function () {
            var $this = $(this);

            $this.data('required', true);

            $this.on('click keydown change', function() {
                $(this).closest('.'+blockName+'__field').removeClass('is-none');
            });
        });

        // Меняем дефолтное поведение обязательных полей
        $('input[required], textarea[required], select[required]', $form).each(function () {
            var $this = $(this);

            $this.removeAttr('required').data('required', true);

            $this.on('click keydown change', function() {
                $(this).closest('.'+blockName+'__field').removeClass('is-none');
            });
        });
    }

    function initFormSubmit () {
        if(isAjax) {
            $form.ajaxForm({
                dataType: (Webprofy.isOldIe() ? 'text' : 'json'),
                beforeSerialize: function(){
                    $form.find('input[name="confirm"]').remove();
                    //$form.find('input[data-fieldname="_utm"]').val(getUserInfo());
                },
                beforeSubmit: function(){
                    var preValidation = checkFields();

                    /* Очищаем все ошибки формы*/
                    var $all_error = $('.'+blockName+'__common-error-placeholder', $context);
                    if($all_error.length) $all_error.html('');
                    $form.find('.form-standart__none.prepend').remove()
                    /*if(preValidation) {
                        $form
                            .find('input[type="submit"]')
                            .prop( "disabled", true)
                            .addClass('is-disabled');
                    }*/

                    return preValidation;
                },
                success: ajaxSuccessHandler,
                error: ajaxErrorHandler
            });
        } else {
            $form.on('submit', checkFields);
        }
    }

    function ajaxSuccessHandler (data) {
        //$form.find('input[type="submit"]').prop( "disabled", false).removeClass('is-disabled');
        $form.find('.error-text').remove();
        $form.find('.is-error').removeClass('is-error');

        if(Webprofy.isOldIe()) {
            eval('var data=' + data);
        }

        if(data.status == 'error'){
            var errorCommonContainer = $('.'+blockName+'__common-error-placeholder', $context);
            $.each(data.errors, function(key, value){
                var $input = $form.find('[data-fieldname="' + key + '"]');
                var $container = $input.closest('.'+blockName+'__field');
                var $error;


                if($container.length > 0){
                    /*$error = $container.find('.'+blockName+'__error');
                    if($error.length==0)
                        $error = $('<div class="'+blockName+'__error"></div>').appendTo($container);

                    $error.text(value);*/
                    $container.addClass('is-error');

                    $input.on('change',function(){
                        $container.removeClass('is-error');
                    });

                } else {
                    if(errorCommonContainer.length > 0){
                        $container = errorCommonContainer;
                    }else{
                        $form.append('<div class="'+blockName+'__common-error-placeholder"></div>');
                        errorCommonContainer = $('.'+blockName+'__common-error-placeholder', $context);
                    }

                    $(errorCommonContainer).append(
                        '<div class="'+blockName+'__common-error"><div class="'+blockName+'__common-error-text">'  + value + '</div></div>'
                    );
                }
            });
            $(document).trigger('webform.error', [$form.attr('name'), data, getFieldsData()]);
        }

        if(data.status == 'success'){
            $(document).trigger('webform.success', [$form.attr('name'), getFieldsData()]);


            if (data.message == undefined) {
                data.message = options.WP_DEFAULT_SUCCESS_MESSAGE;
            }

            switch (options.WP_SUCCESS_MODE) {
                case 'S1':
                    if(data.redirect) {
                        window.location = data.redirect;
                    } else {
                        window.location.reload();
                    }
                    break;
                case 'S2':
                    window.location.reload();
                    break;
                case 'S3':
                    var loc = window.location;
                    if(window.location.href.indexOf('?') + 1) {
                        var popup_get = '&' + options.WP_FORM_ID + '=Y';
                    } else {
                        var popup_get = '?' + options.WP_FORM_ID + '=Y';
                    }
                    window.location = window.location.href + popup_get;
                    break;
                case 'S4':
                    // доработать - Замена содержимого формы на сообщение об успешной отправке без изменения размера формы
                    $form.parent().html('<div class="success-message">' + data.message + '</div>');
                    break;
                case 'S5':
                    if ($('.b-message__content', $context).length > 0) {
                        var $successMessage = $('.b-message__content', $context);
                        $form.parent().html($successMessage);

                    } else {
                        $form.parent().html('<h3 style="margin: 20px" class="success-message">' + data.message + '</h3>');
                    }

                    break;
                case 'S6':
                    // доработать - Замена содержимого формы на сообщение об успешной отправке с последующим полным скрытием формы после небольшой паузы (закрыванием попапа)
                    $form.parent().html('<div class="success-message">' + data.message + '</div>');
                    break;
                case 'S8':
                    /** Используется в Личном кабинете */
                    $.fancybox.close();
                    $.fancybox($successMessage , {
                        afterClose: function(){
                            if($successMessage.hasClass('js-reload-page')){
                                window.location = window.location;
                            }
                        },
                        wrapCSS: 'modal-theme',
                        autoCenter: false,
                        padding: 0,
                        fitToView: false
                    });
                    break;
                case 'S7':
                default:
                    $.fancybox.close();
                    $.fancybox($successMessage , {
                        afterClose: function(){
                            if($successMessage.hasClass('js-reload-page')){
                                window.location = window.location;
                            }
                            $context.find('form').trigger('reset'); // todo: доработать - сброс формы на дефолтное состояние
                        },
                        wrapCSS: 'modal-theme',
                        autoCenter: false,
                        padding: 0,
                        fitToView: false
                    });
                    break;

            }
            // $.fancybox.update();

            /*
                if(data.redirect){
                    document.location = data.redirect;
                } else if(data.message) {
                    $form.parent().html('<div class="success-message">' + data.message + '</div>');
                } else {
                    $.fancybox($successMessage , {
                        afterClose: function(){
                            if($successMessage.hasClass('js-reload-page')){
                                window.location = window.location;
                            }
                        },
                        wrapCSS: 'modal-theme',
                        autoCenter: false,
                        padding: 0,
                        fitToView: false
                    });
                }
            */
        }
    }

    function ajaxErrorHandler (data) {

        let result = {};
        if (data && data.responseText) {
            result =  JSON.parse(data.responseText.replace(/(<([^>]+)>)/gi, '').trim());
        }

        if (result.status === 'success') {
            ajaxSuccessHandler(result)
        }
        if(data.responseJSON.status == 'error') {
            $.each(data.responseJSON.errors, function (key, value) {
                var $input = $form.find('[data-fieldname="' + key + '"]');
                if ($input.length) {
                    var $container = $input.closest('.' + blockName + '__field');
                    var $errorContainer = $container.find('.' + blockName + '__error');

                    $container.addClass('is-error');
                    $errorContainer.text(value);
                } else {
                    $form.find('.form-errors').prepend('<div class="form-standart__none prepend" style="color: #f03">' + value + '</div>')
                }
            });
        }

        if(typeof window.isLocalBuild !== 'undefined') {
            data.status = 'success';
            ajaxSuccessHandler(data);
        } else {
            $form.find('input[type="submit"]').prop( "disabled", false).removeClass('disabled');
            $form.find('.is-captcha-field').addClass('is-error');
        }
    }

    function checkFields () {
        var result = true;

        $fields.each(function () {
            var $field = $(this);
            var $inputs = $('input, textarea, select', $field);
            if($field.hasClass('is-error') || $field.hasClass('is-none')) {
                result = false;
                return;
            }

            $inputs.each(function () {
                var $input = $(this);
                var checkResult = true;
                var isContinue = true;

                /*
                 *TODO: заменить строку ниже, когда будет добавление required на select
                 * if($input.data('required') == undefined) return;
                 */
                if(this.tagName !== 'SELECT' && $input.data('required') == undefined) return;

                function getType(input) {
                    if (input.tagName === 'SELECT') {
                        return 'select'
                    }
                    input.getAttribute('type')
                }

                switch(getType(this)) {
                    case 'checkbox':
                        if(!$input.data('required') || $input.data('necessary') !== 'data-necessary') {
                            checkResult = true && checkResult;
                        } else if($inputs.filter(':checked').length == 0) {
                            checkResult = false;
                            $field.addClass('is-none');
                        }
                        result = checkResult && result;
                        break;

                    case 'radio':
                        if(!$input.data('required') || $input.data('necessary') !== 'data-necessary') {
                            checkResult = true && checkResult;
                        } else if($inputs.filter(':checked').length == 0) {
                            checkResult = false;
                            $field.addClass('is-none');
                        }
                        result = checkResult && result;
                        break;

                    case 'select':
                        checkResult = this.value !== 'not-value'
                        if (!checkResult) {
                            $field.addClass('is-none');
                        }
                        return checkResult && result
                        break;

                    default:
                        if(!$input.data('required')) {
                            checkResult = true && checkResult;
                        } else if($input.val() == '') {
                            checkResult = false;
                            $field.addClass('is-none');
                        }
                        result = checkResult && result;
                        break;
                }
            });
        });

        return result;
    }
};
// Обработка стандартной формы
$(function () {
  $('.form-standart:not(.self-init)').each(function () {
    var $context = $(this);
    var $form = $('form', $context);

    $form.initWebForm('form-standart');

  });


    $('.auth-form:not(.self-init)').each(function () {
        var $context = $(this);
        var $form = $('form', $context);

        $form.initWebForm('auth-form');

    });
    $('.registration-form:not(.self-init)').each(function () {
        var $context = $(this);
        var $form = $('form', $context);

        $form.initWebForm('registration-form');

    });

    $('.forgotpasswd-form:not(.self-init)').each(function () {
        var $context = $(this);
        var $form = $('form', $context);

        $form.initWebForm('forgotpasswd-form');

    });

  function formFieldsValidate($context) {
      var checkVal = function ($input, regExp) {
          var result = regExp.test($input.val());
          if (result) {
              $input.closest('.'+$context[0].classList[0]+'__field').removeClass('is-error');
          } else {
              if ($input.attr('norequeirred') !== undefined) {
                  $input.val('')
                  return true
              } else {
                  $input.closest('.' + $context[0].classList[0] + '__field').addClass('is-error');
              }
          }

          return result;
      };
      $('[data-mask="phone"]').each(function(){
          $(this).mask('+7(999)999-99-99', {autoclear: false});
      });
      $('[data-mask="phone"]').on('blur', function(){
          var regex = /\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/;
          if (
              $(this).val() != ''
              && $(this).val() != '+7(___)___-__-__'
          ) {
              checkVal($(this), regex);
          }
          return true;
      });
      $('[data-type="email"]').on('blur', function(){
          var regex = /^([A-Za-z0-9_-]+\.)*[A-Za-z0-9\+_-]+@[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*\.[a-z]{2,6}$/g;
          checkVal($(this), regex);
          return true;
      });

      $('[data-mask="time"]', $context).each(function () {
          $(this).mask('99-99');
      });

      // Появление полей для смены пароля
      $('.js-pass-link', $context).on('click', function () {
          $context.find('[name=changepassword]').val('1');
          $('.js-pass-change', $context).addClass('is-visible');

          $(this).closest('.form-standart__field').addClass('is-hidden');
          return false;
      });

      $('.js-pass-cancel', $context).on('click', function () {
          $context.find('[name=changepassword]').val('');
          $('.js-pass-change', $context).removeClass('is-visible');
          $('.js-pass-link', $context).closest('.'+$context[0].classList[0]+'__field').removeClass('is-hidden');
          return false;
      });
  }
    function initFormFields($context){
        $context.addClass('is-ready');
        var $form = $context.find('form');
        var $inputs = $('[data-fieldname]', $form);
        var $selects = $('select', $form);
        var $checks = $('input[type="checkbox"], input[type="radio"]', $form);
        var $areas = $('textarea', $form);
        var $datepickers = $('[data-type="date"]', $form);
        var $uploaders = $('.upload-input', $form);
        $inputs.each(function(){
            var $input = $(this);
            var $field = $input.closest('.'+$context[0].classList[0]+'__field');

            if($input.val() !== '') {
                $input.addClass('is-dirty');
                $field.addClass('is-dirty');
                $input.removeClass('is-empty');
                $field.removeClass('is-empty');
            } else {
                $input.addClass('is-empty');
                $field.addClass('is-empty');
                $input.removeClass('is-dirty');
                $field.removeClass('is-dirty');
            }

            $input.on('blur', function(){
                if($input.val() === '') {
                    $input.addClass('is-empty');
                    $field.addClass('is-empty');
                    $input.removeClass('is-dirty');
                    $field.removeClass('is-dirty');
                } else {
                    $input.removeClass('is-empty');
                    $field.removeClass('is-empty');
                    $input.addClass('is-dirty');
                    $field.addClass('is-dirty');
                }
                $field.removeClass('is-focus');
            });

            $input.on('focus', function(){
                $field.addClass('is-focus');
            });

            $input.on('change', function(){
                $input.removeClass('is-empty');
                $input.addClass('is-dirty');
                $field.removeClass('is-empty');
                $field.addClass('is-dirty');
            });

            $input.on('change keyup', function(){
                /*$('.'+$context[0].classList[0]+'__error', $field).remove();*/
                $field.removeClass('is-error');
            });
        });

        $selects.each(function(){
            var $select = $(this);
            var $selectField = $select.closest('.'+$context[0].classList[0]+'__field');

            var placeholder = $select.attr('placeholder');

            $selectField.addClass('is-select-field');
            var templateSR = function (state) {
                var $thstate = $(state.element);

                var $state = $(
                    '<span>' + state.text  + '</span>'
                );
                if($thstate.data('img')){
                    $('<span class="is-img-point" style="background-image: url('+ $thstate.data('img') +')"></span>').prependTo($state);
                }
                if($thstate.data('format')) $state.addClass('is-format-'+ $(state.element).data('format'));
                return $state;
            };

            if (!$(this).hasClass('notdefaultvalue')) {
                this.insertAdjacentHTML('afterBegin', `
                <option value="not-value" selected="selected">Выберете значение</option>
            `);
            }

            $select.select2({
                width: 'style',
                minimumResultsForSearch: 8,
                placeholder: placeholder,
                templateResult: templateSR,
                templateSelection: templateSR,
                "language": {
                    "noResults": function(){
                        return "Ничего не найдено";
                    }
                },
            });
        });

        $checks.each(function(){
            var $check = $(this);
            $check.iCheck();
        });

        $datepickers.each(function(){
            var $datepicker = $(this);
            $datepicker.datepicker({
                multipleDatesSeparator: " - ",
                dateFormat: "dd.mm.yyyy",
                onSelect: function() {
                    $datepicker.datepicker().data('datepicker').hide();
                }
            });
            $datepicker.mask('99.99.9999', {autoclear: false});
        });
        $uploaders.each(function () {
            var $uploader = $(this);
            var $uploaderInput = $('input[type="file"]', $uploader);
            var $uploaderField = $uploader.closest('.'+$context[0].classList[0]+'__field');
            var $uploaded = $('.upload-input__uploaded', $uploader);
            var $uploaderError = $uploaderField.find('.'+$context[0].classList[0]+'__error');

            function getName (str){
                if (str.lastIndexOf('\\')){
                    var i = str.lastIndexOf('\\')+1;
                } else{
                    var i = str.lastIndexOf('/')+1;
                }
                return str.slice(i);
            }

            $uploaderInput.on('change', function () {
                $uploaded.text(getName($(this).val()));
            });
            $uploaded.on('click', function(e){
                $uploaded.text('');
                $uploaderInput.val('');
                $uploaderField.removeClass('is-dirty');
                $uploaderField.addClass('is-empty');
            })
        });

        var checkVal = function ($input, regExp) {
            var result = regExp.test($input.val());
            if (result) {
                $input.closest('.'+$context[0].classList[0]+'__field').removeClass('is-error');
            } else {
                if ($input.attr('norequeirred') !== undefined) {
                    $input.val('');
                    return true;
                } else {
                    $input.closest('.'+$context[0].classList[0]+'__field').addClass('is-error');
                }
            }

            return result;
        };
        $('[data-mask="phone"]').each(function(){
            $(this).mask('+7(999)999-99-99', {autoclear: false});
        });
        $('[data-necessary="data-necessary"] [data-mask="phone"]').on('blur', function(){
            var regex = /\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/;
            if (
                $(this).val() != ''
                && $(this).val() != '+7(___)___-__-__'
            ) {
                checkVal($(this), regex);
            }
            return true;
        });
        $('[data-necessary="data-necessary"] [data-mask="email"]').on('blur', function(){
            var regex = /^([A-Za-z0-9_-]+\.)*[A-Za-z0-9\+_-]+@[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*\.[a-z]{2,6}$/g;
            checkVal($(this), regex);
            return true;
        });

        $('[data-necessary="data-necessary"] [data-mask="email"]').on('invalid', function(e){
            e.preventDefault();
            console.log('invalid email')
        });
        $areas.on('keydown', function(e){
            if(e.which == 13) {e.preventDefault();}
        }).on('input', function(){
            var minHeight = $(this).data('min-height') || 1;
            $(this).height(minHeight);
            var totalHeight = $(this).prop('scrollHeight') - parseInt($(this).css('padding-top')) - parseInt($(this).css('padding-bottom'));
            if(totalHeight > minHeight) {
                $(this).height(totalHeight);
            }
        });
        $areas.filter('[data-min-height]').each(function(){
            var minHeight = $(this).data('min-height');
            if(minHeight){
                $(this).height(minHeight);
            }
        });
    }
    function checkForms() {
        $('.form-standart:not(.is-ready)').each(function(){
            formFieldsValidate($(this));
            initFormFields($(this));
        });

        $('.auth-form:not(.is-ready)').each(function(){
            formFieldsValidate($(this));
            initFormFields($(this));
        });

        $('.registration-form:not(.is-ready)').each(function(){
            formFieldsValidate($(this));
            initFormFields($(this));
        });

        $('.forgotpasswd-form:not(.is-ready)').each(function(){
            formFieldsValidate($(this));
            initFormFields($(this));
        });

        initHints();
    }
    setInterval(checkForms, 100);


    $(document).ready(function() {
        $('a[data-webform-fancybox], button[data-webform-fancybox]').on('click', function(e){
        e.preventDefault();
        let width = $(this).data('width');
        $.ajax({
          type: "POST",
          url: "/ajax/popup_form.php",
          data: {WEB_FORM_ID: $(this).data('form_id'), CURATOR_ID: $(this).data('curator_id')},
          success: function (res) {
            $.fancybox.open(res, {
              width: width
            });
          }
        });
      });
    });
});


